import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CnvDetails from "./components/CnvDetails";
import {
  getVariantResult,
  getVarsomeHost,
} from "../../state/selectors/general.selectors";
import { getCnvPathogenicGenes } from "../../state/selectors/CNVs.selectors";

const CnvDetailsContainer = ({ variantResult, hostUrl, pathogenicGenes }) => {
  if (!variantResult) return null;
  return (
    <CnvDetails
      variantResult={variantResult}
      hostUrl={hostUrl}
      pathogenicGenes={pathogenicGenes}
    />
  );
};

const mapStateToProps = (state) => ({
  variantResult: getVariantResult(state),
  hostUrl: getVarsomeHost(state),
  pathogenicGenes: getCnvPathogenicGenes(state),
});

CnvDetailsContainer.propTypes = {
  variantResult: PropTypes.shape({
    coding_gene_id: PropTypes.arrayOf(PropTypes.number),
    coding_genes: PropTypes.arrayOf(PropTypes.string),
    deleted_data_reason: PropTypes.string,
    exon: PropTypes.arrayOf(PropTypes.string),
    gene_id: PropTypes.arrayOf(PropTypes.number),
    gene_symbol: PropTypes.arrayOf(PropTypes.string),
    end: PropTypes.number,
    length: PropTypes.number,
    pos: PropTypes.number,
  }),
  hostUrl: PropTypes.string,
  pathogenicGenes: PropTypes.arrayOf(
    PropTypes.shape({
      disease: PropTypes.arrayOf(PropTypes.string),
      gene: PropTypes.string,
    })
  ),
};

CnvDetailsContainer.defaultProps = {
  variantResult: {},
  hostUrl: "",
  pathogenicGenes: null,
};

export default connect(mapStateToProps)(CnvDetailsContainer);
